// extracted by mini-css-extract-plugin
export default {"title":"style_title__N+9xE","text":"style_text__ca5dd"};